import './ExpandToggle.scss';

import { IconChevronRight, IconChevronUp } from '@hulu-react-style-components/icons';
import React from 'react';

type ExpandToggleProps = {
  isExpanded: boolean;
  onToggle: () => void;
};

const ExpandToggle = ({ isExpanded, onToggle }: ExpandToggleProps): React.JSX.Element => {
  return (
    <button className="expand-toggle" onClick={onToggle} type="button">
      {isExpanded ? <IconChevronUp title="collapse" /> : <IconChevronRight title="expand" />}
    </button>
  );
};

export default ExpandToggle;
